import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { basePlanningBoardEffects, basePlanningBoardReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('planningBoard', basePlanningBoardReducer.BasePlanningBoardReducer),
    EffectsModule.forFeature([basePlanningBoardEffects.BasePlanningBoardEffects]),
  ],
})
export class BasePlanningBoardStoreModule {}
